import { render, staticRenderFns } from "./RemoteConfigModal.vue?vue&type=template&id=28fd40b6&scoped=true&"
import script from "./RemoteConfigModal.vue?vue&type=script&lang=js&"
export * from "./RemoteConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoteConfigModal.vue?vue&type=style&index=0&id=28fd40b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd40b6",
  null
  
)

export default component.exports